import axios from 'axios';

export default class HomeService {
  public getUnifiedOffers(page: number = 0, size: number = 6): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const url = `api/unified-offers?page=${page}&size=${size}&sort=activationDatetime,desc`;
      axios
        .get(url)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getUnifiedDemands(page: number = 0, size: number = 6): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const url = `api/unified-demands?page=${page}&size=${size}&sort=activationDatetime,desc`;
      axios
        .get(url)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
